import React, { useState } from 'react';
import {
    Button, ButtonGroup, Menu, MenuItem,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

// Split button: clicking the main area downloads XLSX directly (the default);
// the arrow opens a menu to pick CSV or XLSX explicitly.
export default function DownloadSplitButton({
    label,
    csvLabel,
    xlsxLabel,
    onDownload,
    variant = 'outlined',
    size = 'small',
    buttonSx,
    arrowSx,
}) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleSelect = (format) => {
        setAnchorEl(null);
        onDownload(format);
    };

    return (
        <>
            <ButtonGroup variant={variant} size={size}>
                <Button
                    onClick={() => onDownload('xlsx')}
                    startIcon={<FileDownloadOutlinedIcon fontSize="small"/>}
                    sx={buttonSx}
                >
                    {label}
                </Button>
                <Button
                    onClick={(e) => setAnchorEl(e.currentTarget)}
                    sx={{ px: 0.5, minWidth: 'auto', ...arrowSx }}
                >
                    <ArrowDropDownIcon fontSize="small"/>
                </Button>
            </ButtonGroup>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <MenuItem onClick={() => handleSelect('csv')} sx={{ fontSize: 13 }}>{csvLabel}</MenuItem>
                <MenuItem onClick={() => handleSelect('xlsx')} sx={{ fontSize: 13 }}>{xlsxLabel}</MenuItem>
            </Menu>
        </>
    );
}
